import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import BlobUtil from '../../utils/blobUtil'
import { Redirect } from 'react-router-dom';
import { IUser, IUserCourse } from '../../store/interface'
import { selectCourse as selectCourseAction } from '../../store/myCourse/actions'
import { getMySelectedCourse } from '../../store/myCourse/selectors'
import { fetchRequest as getMyCourseAction } from '../../store/myCourse/actions'
import { editRequest as updateMyCourseAction } from '../../store/myCourse/actions'
import { askTrainerRequest as askTrainerAction } from '../../store/myCourse/actions'
import { getMyCourseById } from '../../store/myCourse/selectors';
import { fetchRequest as getCourseAction } from '../../store/course/actions'
import { getCourseByCourseId } from '../../store/course/selectors';
import { Link, NavLink as RouterNavLink } from 'react-router-dom';

import Player from './Player';

import { store } from 'react-notifications-component';
import VideoPlayer from './VideoPlayer';
import { UserCourseUtil } from '../../utils/dataUtil'
import { Spinner, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label }
    from 'reactstrap';
import PlayerControl from './PlayerControl';
import Concentration from './concentration';

import { GeneralUtil } from '../../utils/generalUtil';

import {
    Collapse,
    Container,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import '@fortawesome/fontawesome-free/css/all.css';

const generalUtil: GeneralUtil = new GeneralUtil();
// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    selected?: IUserCourse
    route: any
    user: IUser
    data: any
}

interface IPopupImage {
    image?: string[]
    show: boolean
    loadImage: boolean
}
interface IState {
    [key: string]: any
    videoUrl : string
    fireRedirect: any
    start: boolean
    initConcentrationQuestion: boolean
    playing: boolean
    startFrom?: number
    lastUpdateSeconds?: number
    stop: boolean
    popupImage: IPopupImage
    isOpen: boolean
    selectedImageUrl: string
    showConcentrationAnswer: string
    concerntrationTargetImages: string
    allowToPlay: boolean
    rewind: { isRewind: boolean, duration: number }
    modalAskTrainer: boolean
    modalAskTrainerResponse: boolean
    modalCompleteWatch: boolean
    AskBody: string
    CourseId: string
    modalUserGuidesTips: boolean
    wrongAnswer: boolean
    correctAnswer : boolean
    isCompleteWatch : boolean
    isCompleteWatchInit : boolean
}
// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    selectCourse: typeof selectCourseAction
    fetchRequest: typeof getMyCourseAction
    editRequest: typeof updateMyCourseAction
    askTrainerRequest: typeof askTrainerAction
    fetchCourseRequest: typeof getCourseAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

class PlayerViewPage extends React.Component<AllProps, IState> {
    tempPlayerCurrentTime: number = 0;
    blobUtil: BlobUtil;

    concerntrationImages: string[][] = [];
    // concerntrationImages: string[][] = [
    //     [   '/concentration/balls/ball_01.png',
    //         '/concentration/balls/ball_02.jpg',
    //         '/concentration/balls/ball_03.jpg',
    //         '/concentration/balls/ball_04.jpg',
    //         '/concentration/balls/ball_05.png'], 
    //     [   '/concentration/buildings/building_01.png',
    //         '/concentration/buildings/building_02.png',
    //         '/concentration/buildings/building_03.png',
    //         '/concentration/buildings/building_04.png',
    //         '/concentration/buildings/building_05.png'], 
    //     [   '/concentration/fruits/fruit_01.jpg',
    //         '/concentration/fruits/fruit_02.png',
    //         '/concentration/fruits/fruit_03.png',
    //         '/concentration/fruits/fruit_04.jpg',
    //         '/concentration/fruits/fruit_05.jpg'], 
    //     [   '/concentration/transports/transport_01.jpg',
    //         '/concentration/transports/transport_02.jpg',
    //         '/concentration/transports/transport_03.jpg',
    //         '/concentration/transports/transport_04.jpg',
    //         '/concentration/transports/transport_05.jpg']
    // ];

    concerntrationChecker?: Concentration;
    userCourseData = new UserCourseUtil();
    constructor(props: AllProps) {
        super(props)
        //this.handleEdit = this.handleEdit.bind(this)
        this.state = {
            videoUrl : "",
            fireRedirect: false,
            start: false,
            initConcentrationQuestion : false,
            playing: false,
            startFrom: (this.props.data === undefined || this.props.data.playUntilSeconds === undefined) ? undefined : this.props.data.playUntilSeconds,
            stop: false,
            popupImage: { show: false, loadImage: false },
            isOpen: false,
            selectedImageUrl: "",
            showConcentrationAnswer: "",
            concerntrationTargetImages: "",
            allowToPlay: false,
            rewind: { isRewind: false, duration: 0 },
            modalAskTrainer: false,
            modalAskTrainerResponse: false,
            modalCompleteWatch: false,
            AskBody: '',
            CourseId: '',
            modalUserGuidesTips: false,
            wrongAnswer: false,
            correctAnswer : false,
            isCompleteWatch : false,
            isCompleteWatchInit : false
        }
        const id = this.props.route.match.params.id;
        this.props.selectCourse(id);
        this.blobUtil = new BlobUtil();
        this.handleResetPlay = this.handleResetPlay.bind(this);
        this.handleModalAskTrainer = this.handleModalAskTrainer.bind(this);
        this.handleModalAskTrainerResponse = this.handleModalAskTrainerResponse.bind(this);
        this.handleSendAskTrainer = this.handleSendAskTrainer.bind(this);
        this.handleModalCompleteWatch = this.handleModalCompleteWatch.bind(this);
        this.handleModalUserGuidesTips = this.handleModalUserGuidesTips.bind(this);
        this.handleResetAnswer = this.handleResetAnswer.bind(this);
        this.handleUpdatePhotoFile = this.handleUpdatePhotoFile.bind(this);
    }

    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }
    /*
    handleEdit(target:any){

        if(this.props.selected){
            this.props.editCompany({...this.props.selected})
            this.setState({ fireRedirect: true })
        }
    }
    */

    public componentDidMount() {
        //const { fetchCourseRequest: fr, data } = this.props;
        //console.log("Course Player Index Mount");

        this.concerntrationChecker = undefined;

        // const script = document.createElement("script");
        // script.src = "https://cdn.jsdelivr.net/npm/@tensorflow/tfjs";
        // script.async = true;    
        // document.body.appendChild(script);
        // const script2 = document.createElement("script");
        // script2.src = "https://cdn.jsdelivr.net/npm/@tensorflow-models/coco-ssd";
        // script2.async = true;    
        // document.body.appendChild(script2);

    }

    componentWillUnmount() {
        //console.log("Course Player Index Unmount");
        this.concerntrationChecker = undefined;
    }

    async componentDidUpdate(prevProps: AllProps) {
        //console.log(prevProps);

        if (prevProps.route.location.pathname !== this.props.route.location.pathname) {
            window.location.reload();
        }

        //console.log("componentDidUpdate");
        /*
        if (this.props.data !== undefined && this.props.data.courseId != this.state.CourseId){
            this.setState({
                CourseId: this.props.data.courseId
            }, ()=> {
                const { fetchCourseRequest: fr, data } = this.props;
                var searchParams:any = {};
                searchParams["courseId"] = this.state.CourseId;
                searchParams["offset"] = 0;
                searchParams["limit"] = 1;
                fr(searchParams);
            })
        }
        */
    //    if (this.state.videoUrl ===""){
    //         let blobUrl = await this.getVideoUrl(this.props.data?.videoURL);
    //         this.setState({videoUrl : blobUrl});
    //    }
         //if (prevProps.data === undefined && this.props.data !==undefined && this.props.data.playUntilSeconds ){
        if (!this.state.isCompleteWatchInit && this.props.data !==undefined){
            if (this.props.data.courseDuration == this.props.data.playUntilSeconds){
                console.log("==> Completed Watch. Set Allow to Play");
                await this.setState({isCompleteWatch : true, allowToPlay : true, isCompleteWatchInit : true});
            }else{
                await this.setState({isCompleteWatchInit : true});
            }
        }

        if (this.props.data !== undefined) {

           
            // && this.state.startFrom !== this.props.data.playUntilSeconds ){
            //&& this.state.startFrom === 0 ){
            if (this.state.startFrom === undefined) {
                // && prevProps.data.playUntilSeconds !== this.props.data.playUntilSeconds
                this.setState({
                    startFrom: this.props.data.playUntilSeconds
                });
            }

            if (this.concerntrationChecker === undefined) {

                this.concerntrationChecker = new Concentration({
                    skipDuration: this.props.data.playUntilSeconds,
                    checkPoint: this.props.data.concentrationDurationSettingsJSON
                });
                //this.prepareConcerntrationTargetImages();

                //concerntrationImages
                if (this.props.data?.concentrationId){
                    let concentrationResult = await generalUtil.Read(this.props.data?.concentrationId, "Concentration");
                    if (concentrationResult.isSuccess){
                       let concentrationPictures = concentrationResult.doc;
                       concentrationPictures.categories.map((c:any) => {
                        let picArray:any = [];
                        c.pictures.map((pic:string) => {
                                //console.log("==> Pic :" + pic);
                                picArray.push(this.GetImagePath(pic));
                            }
                        )
                        this.concerntrationImages.push(picArray);
                        });
                    }
                }

                // if (this.props.data.concentrationPictures?.categories){
                //     console.log("!!Read concerntrationImages Image path");
                //     this.props.data.concentrationPictures.categories.map((c:any) => {
                //         let picArray:any = [];
                //         c.pictures.map((pic:string) => {
                //                 //console.log("==> Pic :" + pic);
                //                 picArray.push(this.GetImagePath(pic));
                //             }
                //         )
                //         this.concerntrationImages.push(picArray);
                //     });
                //     //console.log(this.concerntrationImages);
                // }


                this.concerntrationChecker.GetNextConcentrationCheckPoint(this.props.data.playUntilSeconds);

                this.concerntrationChecker.LoggedIn.on((evt: any) => {
                    //console.log(evt);
                    this.ShowAnswerDialog();
                });
                this.concerntrationChecker.LoggedOut.on((evt: any) => {
                    //console.log(evt);
                    this.ShowQuestionDailog();

                });
            }
        }
    }


    private StartRecognition() {
        //console.log('The link was clicked.');
        //this.setState({ playing:true});
        this.setState({ start: true });
    }
    private StopRecognition() {
        //console.log('The link was clicked.');
        //this.setState({ playing:false, stop:false});

        if (!this.state.isCompleteWatch){
            this.setState({ start: false });
        }
    }

    GetImagePath(fileName: string){
        fileName = fileName.replace(".jpg","_200x200.jpg").replace(".png","_200x200.png");
        return "https://images.ultimatespro.com/images/" + fileName;
    }

    getRandomInt(max: number) {
        return Math.floor(Math.random() * Math.floor(max));
    }

    private playerCurrentTime(seconds: number) {
        this.tempPlayerCurrentTime = seconds;

        if (this.state.lastUpdateSeconds == null || this.state.lastUpdateSeconds == undefined){
            this.setState({lastUpdateSeconds : seconds});
        }

        // Update Every Minutes
        if (parseInt(seconds.toString()) > 0 
            && (parseInt(seconds.toString()) % 60 === 0)
            && ((seconds - this.state.lastUpdateSeconds) > 2)
            ){
             if (seconds > this.props.data.playUntilSeconds){
                this.setState({lastUpdateSeconds : seconds});
                this.props.editRequest({ 
                    id: this.props.data.id, lastWatchDT:new Date(),  
                    playUntilSeconds: this.tempPlayerCurrentTime.toFixed(0) 
                });
             }
        }

        if (this.concerntrationChecker !== undefined) {
            this.concerntrationChecker.CurrentDuration(this.tempPlayerCurrentTime);
        }
    }

    private prepareConcerntrationTargetImages() {   
        //console.log("!!! START prepareConcerntrationTargetImages !!!");
        if (this.concerntrationImages.length > 0){ // If concentration images
            const concerntrationTargetCategoryIndex = this.getRandomInt(4);
            // console.log("==> Random index : " + concerntrationTargetCategoryIndex);
            // console.log("==> Concentration Images " + this.concerntrationImages);
            
            const categorySelectionImageIndex = this.getRandomInt(this.concerntrationImages[concerntrationTargetCategoryIndex].length);
            const concerntrationTargetImages = this.concerntrationImages[concerntrationTargetCategoryIndex][categorySelectionImageIndex];

            let images: string[] = [concerntrationTargetImages];
            for (let _categoryIndex = 0; _categoryIndex < 4; _categoryIndex++) {

                if (concerntrationTargetCategoryIndex !== _categoryIndex) {
                    let imageIndex = this.getRandomInt(this.concerntrationImages[_categoryIndex].length);
                    images.push(this.concerntrationImages[_categoryIndex][imageIndex]);
                }

            }

            let outImages: string[] = [];

            //console.log("Contentration Images:" + JSON.stringify(images));

            outImages.push(images.splice(this.getRandomInt(4), 1)[0]);
            outImages.push(images.splice(this.getRandomInt(3), 1)[0]);
            outImages.push(images.splice(this.getRandomInt(2), 1)[0]);
            outImages.push(images[0]);

            this.setState({
                concerntrationTargetImages: concerntrationTargetImages,
                popupImage: {
                    ...this.state.popupImage, loadImage: true,
                    image: outImages
                }
            });
            this.setState({ initConcentrationQuestion: true });
        }
    }
    getDataUrl(img: any) {
        // Create canvas
        const canvas: any = document.createElement('canvas');
        const ctx: any = canvas.getContext('2d');
        // Set width and height
        canvas.width = img.width;
        canvas.height = img.height;
        // Draw the image
        ctx.drawImage(img, 0, 0);
        return canvas.toDataURL('image/jpeg');
    }

    private ShowAnswerDialog() {
        this.setState(
            {
                showConcentrationAnswer: this.state.concerntrationTargetImages
            });
    }

    private ShowQuestionDailog() {
        this.setState(
            {
                start: false,
                allowToPlay: false,
                selectedImageUrl: "",
                popupImage: { ...this.state.popupImage, show: !this.state.popupImage.show, loadImage: false }
            });
    }

    // private lastPlaySeconds(seconds:number){
    //     if (seconds !== 0){
    //         console.log("*** Updating Last play time at : " + seconds);
    //         const courseId = this.props.route.match.params.id;
    //         this.userCourseData.Update(courseId, {currentTime:seconds }).then(
    //             //console.log
    //         ).catch(console.log);

    //     }
    // }
    private played() {
        if (this.state.start === false) {
            this.setState({ start: true });

            //this.prepareConcerntrationTargetImages(); // Setting here everytime stop and play very regenerate new question and anser
            
        }
        if (this.state.initConcentrationQuestion === false){ // Initialise first time only
            //console.log("!!!!! Initialised Concentration Question!!!!")
            //this.setState({ initConcentrationQuestion: true });
            this.prepareConcerntrationTargetImages();
        }
    }
    private stopped() {
        if (this.state.start === true) {
            this.setState({ start: false });
        }
    }
    private async GetSelectedImage(imageUrl: string) {
        if (this.concerntrationChecker === undefined)
            return;

        if (imageUrl.indexOf(this.state.showConcentrationAnswer) >= 0) {
            //console.log("User selected the correct Answer");
            this.setState({
                selectedImageUrl: imageUrl,
                showConcentrationAnswer: "",
                wrongAnswer: false,
                correctAnswer : true,
                start: true,
                popupImage: { ...this.state.popupImage, show: false, loadImage: false, image: [] },
                allowToPlay: true,
                startFrom: this.tempPlayerCurrentTime
            }, this.prepareConcerntrationTargetImages);

            this.props.editRequest({ id: this.props.data.id, lastWatchDT:new Date(),  playUntilSeconds: this.tempPlayerCurrentTime.toFixed(0) });

            // Capture photo whenever choosen correct answer as evidence


            this.concerntrationChecker.GetNextConcentrationCheckPoint(this.tempPlayerCurrentTime);
        } else {
            //console.log("User selected wrong answer!");

            // const repeatForm= this.concerntrationChecker.RepeatConcentrationCheckPoint();
            // this.setState({
            //     wrongAnswer: true,
            //     start:true,
            //     selectedImageUrl:imageUrl,
            //     allowToPlay:true,
            //     showConcentrationAnswer:"",
            //     rewind:{isRewind:true, duration: repeatForm},
            //     popupImage:{...this.state.popupImage,show:false,loadImage:false,image:[]}
            // },this.prepareConcerntrationTargetImages);

            const repeatForm = this.concerntrationChecker.GetRepeatConcentrationCheckPointRestartDuration();
            // console.log("Set video to repeat from :" + repeatForm);
            await this.setState({
                wrongAnswer: true,
                correctAnswer : false,
                start: true,
                selectedImageUrl: imageUrl,
                allowToPlay: true,
                showConcentrationAnswer: "",
                rewind: { isRewind: true, duration: repeatForm },
                popupImage: { ...this.state.popupImage, show: false, loadImage: false, image: [] }
            }, this.prepareConcerntrationTargetImages);

            //console.log("Done reset state. Setting RepeatConcentrationCheckPoint");
            this.concerntrationChecker.CurrentDuration(repeatForm);
            this.concerntrationChecker.RepeatConcentrationCheckPoint();
            //this.prepareConcerntrationTargetImages;
            //console.log("Done reset state. Complete set RepeatConcentrationCheckPoint");

        }
    }
    setAllowToPlay(isAllow: boolean) {
        if (!this.state.isCompleteWatch){
            if (this.state.popupImage.show === false) {
                this.setState({
                    allowToPlay: isAllow
                });
            }
        }
    }

    handleUpdatePhotoFile(fileName:string){
        let currentImageList = this.props.data?.faceImageList ?? [];
        currentImageList.push(fileName);
        this.props.editRequest({ 
            id: this.props.data.id, 
            faceImageList : currentImageList
        });
    }

    handleResetPlay() {
        this.props.editRequest({ id: this.props.data.id, playUntilSeconds: 0, feedbackSubmitted: false, certIsGenerated: false });

        store.addNotification({
            title: "info",
            message: "Please refresh",
            type: "success",
            insert: "top",
            container: "top-center",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 3000,
                onScreen: true
            }
        });
    }
    handleResetAnswer(){
        this.setState({ correctAnswer : false, wrongAnswer : false});
    }
    handleModalAskTrainer() {
        this.setState({ modalAskTrainer: !this.state.modalAskTrainer });
    }
    handleModalAskTrainerResponse() {
        this.setState({ modalAskTrainerResponse: !this.state.modalAskTrainerResponse });
    }
    handleModalCompleteWatch() {
        let isFeedbackSubmitted = this.props.data?.feedbackSubmitted ?? false;

        if (!isFeedbackSubmitted) {
            this.props.editRequest({ id: this.props.data.id, completeWatchDT: new Date(), playUntilSeconds: this.props.data.courseDuration });

            this.setState({ modalCompleteWatch: !this.state.modalCompleteWatch });
        }
    }
    handleSendAskTrainer() {
        // This will not work if user refresh page
        //let course = this.props.courseData.findFirst((f:any) => f.courseId === this.state.CourseId);

        let doc: any = {};
        doc.subject = "Question-" + this.props.data.courseTitle;
        doc.body = this.state.AskBody.replace(/\n/gi, '<br/>');
        doc.userId = this.props.user.emailAdd; // CC TO User Email
        doc.userName = this.props.user.fullName; // User Name
        doc.trainerEmail = this.props.data.organiser.userId; // Trainer Email
        doc.trainerName = this.props.data.organiser.name; // Trainer Name
        doc.courseTitle = this.props.data.courseTitle;

        const { askTrainerRequest: send } = this.props;
        send(doc);

        // Update on user course
        let currentUserQuestion = this.props.data.userQuestion;
        let newUserQuestion: any = {};
        newUserQuestion.sendDt = new Date();
        newUserQuestion.body = this.state.AskBody;
        currentUserQuestion.push(newUserQuestion);
        this.props.editRequest({ id: this.props.data.id, userQuestion: currentUserQuestion });

        //this.setState({modalAskTrainer : !this.state.modalAskTrainer});
        this.setState({ modalAskTrainerResponse: !this.state.modalAskTrainerResponse });
    }

    handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { target } = event;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;
        this.setState({
            [name]: value,
        });

        //console.log(value);
    }
    handleModalUserGuidesTips() {
        this.setState({ modalUserGuidesTips: !this.state.modalUserGuidesTips });
    }

    public render(): any {
        if (this.props.user && (this.props.user.personId === undefined || this.props.user.personId === '')) {
            //alert("Require update user profile before can be proceed");
            alert("Please perform face recognition before proceed to attend seminar");
            return <Redirect to="/profile" />
        }
        else {
            if (this.props.data) {
                return <Fragment> {this.RenderLayout()} {this.render2()}</Fragment>;
            } else {
                return <Fragment><Spinner color="warning" /></Fragment>
            }
        }
    }

    public RenderLayout() {
        return (
            <div>
                <Navbar color="" dark expand="md" fixed="top" style={{ backgroundColor: "#3A3A3C" }}>
                    <Container fluid={true}>
                        <NavbarBrand href="/#/mycourses/">
                            <img src="/images/logo.png" height="40px" alt="Logo" />
                        </NavbarBrand>
                        <Nav className="mr-auto" navbar>
                            <NavItem>
                                <span style={{ color: "#fff", fontSize: "larger", fontWeight: "bolder" }}>
                                    {this.props.data.courseTitle}
                                </span>

                            </NavItem>
                        </Nav>
                        <NavbarToggler onClick={this.toggle.bind(this)} />
                        <Collapse isOpen={this.state.isOpen} navbar>
                            <Nav className="mr-auto" navbar>

                            </Nav>
                            <Nav className="justify-content-end" navbar>
                                <NavItem>
                                    <span style={{ color: "#fff", cursor: "pointer" }} onClick={this.handleModalUserGuidesTips}>Tips</span>

                                    <Modal size="lg" isOpen={this.state.modalUserGuidesTips} unmountOnClose={true}>
                                        <ModalHeader toggle={this.handleModalUserGuidesTips}>User Guides / Tips</ModalHeader>
                                        <ModalBody>
                                            <Label>On Camera</Label>
                                            <ol>
                                                <li>The camera will detect your face every 5 minutes while you attend the course</li>
                                                <li>The course will pause if face is unable to recognized</li>
                                                <li>Use soft lighting from the front, avoid over exposure.</li>
                                                <li>Cleanliness of the camera is vital for a clear shot</li>
                                                <li>Camera detection within 0.5m to 1m</li>
                                            </ol>
                                            <Label>On Video</Label>
                                            <ol>
                                                <li>Each user account can only play a single video at a time</li>
                                                <li>Videos are not allowed to fast forward</li>
                                                <li>Video will pause if face is unable to be recognized, user only can continue from last verified face video play time.</li>
                                                <li>When course is paused by yourself, you can continue to play from the part where the video is paused.</li>
                                                <li>There will be a Concentration Test Question popup within 15 minutes, (with 2 seconds of picture). If you able to answer, the video will be continued. If you are unable to answer, the video will replay again from the last frame. </li>
                                            </ol>
                                        </ModalBody>
                                        <ModalFooter>
                                            {/* <Button color="primary" onClick={this.handleSendAskTrainer}>Send</Button>{' '} */}
                                            <Button color="secondary" onClick={this.handleModalUserGuidesTips}>Close</Button>
                                        </ModalFooter>
                                    </Modal>
                                </NavItem>
                            </Nav>
                        </Collapse>
                    </Container>
                </Navbar>
            </div>
        );

    }

    async getVideoUrl(fileName:string) {
        let blobRequestUrl = "";
        return blobRequestUrl;
    }
    public render2() {
        const { from } = this.props.route.location.state || '/'

        const { selected } = this.props
        const { fireRedirect } = this.state
        const id = this.props.route.match.params.id;
        //const sectionId = this.props.route.match.params.sectionId;
        // const sourceVideo = {
        //     "src": "//amssamples.streaming.mediaservices.windows.net/91492735-c523-432b-ba01-faba6c2206a2/AzureMediaServicesPromo.ism/manifest",
        //     "type": "application/vnd.ms-sstr+xml"
        //   };

        const sourceVideo = {
            //"src": "/courses/V" + this.props.route.match.params.id + ".mp4",
            //"src": this.getVideoUrl(this.props.data?.videoURL) ?? "",
            "src": this.props.data?.videoURL ?? "",
            //"src": this.state.videoUrl,
            "type": "video/mp4"
        };

        //console.log(this.state);
        return (
            <React.Fragment>
                
                {
                    this.props.data && (
                        <React.Fragment>

                            <div className="row">
                                <div className="col-lg-10 col-md-9" style={{ paddingLeft: "30px", paddingRight: "30px" }}>
                                    <div className="row">
                                        <div className="col-md-12">

                                            <VideoPlayer
                                                sourceVideo={sourceVideo}
                                                videoThumbnail={this.props.data.videoThumbnailURL}
                                                playerCurrentTime={this.playerCurrentTime.bind(this)}
                                                startFrom={this.state.startFrom}
                                                popupImage={this.state.popupImage}
                                                selectedImage={this.GetSelectedImage.bind(this)}
                                                showConcentrationAnswer={this.state.showConcentrationAnswer}
                                                allowToPlay={this.state.allowToPlay}
                                                checkAllowToPlay={true}
                                                start={this.state.start}
                                                played={this.played.bind(this)}
                                                stopped={this.stopped.bind(this)}
                                                completed={this.handleModalCompleteWatch.bind(this)}
                                                rewind={this.state.rewind}
                                                videoDuration={this.props.data.courseDuration}
                                            />

                                            {/*
                                <Player playing={this.state.playing} 
                                startFrom={this.props.data.playUntilSeconds} 
                                start={this.state.start}
                                sourceVideo={sourceVideo} 
                                lastPlaySeconds={this.lastPlaySeconds.bind(this)} 
                                played={this.played.bind(this)} 
                                stopped={this.stopped.bind(this)}
                                playerCurrentTime={this.playerCurrentTime.bind(this)}
                                popupImage={this.state.popupImage}
                                selectedImage={this.GetSelectedImage.bind(this)}
                                showConcentrationAnswer={this.state.showConcentrationAnswer}
                                />
*/}
                                        </div>

                                        {/* <div className="col-md-12">
                                <form>
                                    <div className="form-group">
                                        <label>Comments:</label>
                                        <textarea className="form-control"  rows={3}></textarea>
                                    </div>
                                    <button type="button" className="btn btn-primary">Submit</button>
                                </form>
                            </div> */}
                                    </div>
                                    <Modal size="lg" isOpen={this.state.modalCompleteWatch} toggle={this.handleModalCompleteWatch} unmountOnClose={true}>
                                        <ModalHeader toggle={this.handleModalCompleteWatch}>Course Completed</ModalHeader>
                                        <ModalBody>
                                            Congratulations! You have completed the course!<br />
                               Please submit your feedback to generate the certificate.
                            </ModalBody>
                                        <ModalFooter>
                                            <Link to={'/mycourses/feedback/' + this.props.route.match.params.id} className="btn btn-primary">Submit Feedback</Link>{' '}
                                            <Button color="secondary" onClick={this.handleModalCompleteWatch}>Replay Video</Button>
                                        </ModalFooter>
                                    </Modal>
                                </div>
                                <div className="col-lg-2 col-md-3">

                                    <p style={{ textAlign: "center" }}>{this.state.allowToPlay ?
                                        (<span><i className="fas fa-play-circle mr-1" style={{ fontSize: "xx-large", color: "green" }}></i>Click on Video to Start</span>)
                                        :
                                        (<span><i className="fas fa-stop-circle mr-1" style={{ fontSize: "xx-large", color: "red" }}></i>Video Paused</span>)
                                    }
                                    </p>

                                    <PlayerControl start={this.StartRecognition.bind(this)} stop={this.StopRecognition.bind(this)}
                                        askTrainer={this.handleModalAskTrainer.bind(this)} 
                                        resetPlay={this.handleResetPlay.bind(this)}
                                        videoStart={this.state.start}
                                        resetAnswer={this.handleResetAnswer.bind(this)}
                                        wrongAnswer={this.state.wrongAnswer} 
                                        correctAnswer={this.state.correctAnswer} 
                                        completeWatch={this.state.modalCompleteWatch} 
                                        setAllowToPlay={this.setAllowToPlay.bind(this)}
                                        updatePhotoFile={this.handleUpdatePhotoFile.bind(this)} 
                                        userCourseData={this.props.data}
                                        isCompleteWatch={this.state.isCompleteWatch}
                                    />

                                    <Modal size="lg" isOpen={this.state.modalAskTrainer} toggle={this.handleModalAskTrainer} unmountOnClose={true}>
                                        <ModalHeader toggle={this.handleModalAskTrainer}>Ask Question</ModalHeader>
                                        <ModalBody>
                                            <Label>Question</Label>
                                            <Input type="textarea" name="AskBody" id="AskBody" value={this.state.AskBody}
                                                placeholder="Type your question here..." rows={8}
                                                onChange={this.handleChange.bind(this)}
                                            />

                                            <Modal isOpen={this.state.modalAskTrainerResponse} toggle={this.handleModalAskTrainerResponse} onClosed={this.handleModalAskTrainer}>
                                                <ModalHeader>Status</ModalHeader>
                                                <ModalBody>Sent successfully.</ModalBody>
                                                <ModalFooter>
                                                    {/* <Button color="primary" onClick={toggleNested}>Done</Button>{' '} */}
                                                    <Button color="secondary" onClick={this.handleModalAskTrainerResponse}>Ok</Button>
                                                </ModalFooter>
                                            </Modal>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button color="primary" onClick={this.handleSendAskTrainer}>Send</Button>{' '}
                                            <Button color="secondary" onClick={this.handleModalAskTrainer}>Cancel</Button>
                                        </ModalFooter>
                                    </Modal>
                                </div>
                            </div>


                            {/**
                        <div>Expected Image is {this.state.showConcentrationAnswer}</div>
                        <div>Selected Image is {this.state.selectedImageUrl}</div>
                         
                        <textarea rows={15} style={{minWidth:"100%"}} >{JSON.stringify(this.state, null, 1)}</textarea>
                        */}
                            {/* {JSON.stringify(this.props.courseData)} */}

                            {/* {
                                JSON.stringify(this.props.data)
                            } */}
                        </React.Fragment>
                    )
                }

            </React.Fragment>
        );

    }

}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState, ownProps: any) => ({
    //data:company.data,
    //user: state.userReducer
    user: state.userInfo.byId[0],
    //selected: getMySelectedCourse(state, ownProps.route.match.params.id),
    data: getMySelectedCourse(state, ownProps.route.match.params.id)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    selectCourse: selectCourseAction,
    fetchRequest: getMyCourseAction,
    editRequest: updateMyCourseAction,
    askTrainerRequest: askTrainerAction,
    fetchCourseRequest: getCourseAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PlayerViewPage)
